import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import HTMLReactParser from "html-react-parser";
import React from "react";
import { Helmet } from "react-helmet";

const GlobalMeta = () => {
  //get yoast header meta
  const { data } = useQuery({
    queryKey: ["meta", window.location.href],
    queryFn: () =>
      axios({
        method: "get",
        url: `${WP_API_Settings.endpoint}yoast/v1/get_head?url=${window.location.href}`,
      }),
    retry: 1,
    notifyOnChangeProps: window.location.href,
    //enabled : !!process.env.NODE_ENV === "production"
  });
  //console.log(window.location.href);

  return (
    <>
      {data?.data?.html ? (
        <Helmet>
          {HTMLReactParser(data.data.html)}

          {/* <title>{yoast_head_json.title}</title>
                    <meta name="description" content={yoast_head_json.og_description} />
                    <meta name="robots" content={`${yoast_head_json.robots.index}, ${yoast_head_json.robots.follow}, ${yoast_head_json.robots['max-image-preview']}, ${yoast_head_json.robots['max-snippet']}, ${yoast_head_json.robots['max-video-preview']}`} />
                   <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" /> 
                    <link rel="canonical" href={yoast_head_json.canonical} />
                    <meta property="og:locale" content={yoast_head_json.og_locale} />
                    <meta property="og:type" content={yoast_head_json.og_type} />
                    <meta property="og:title" content={yoast_head_json.og_title} />
                    <meta property="og:description" content={yoast_head_json.og_description} />
                    <meta property="og:url" content={yoast_head_json.canonical} />
                    <meta property="og:site_name" content={yoast_head_json.title} />
                    <meta name="twitter:card" content={yoast_head_json.twitter_card} />
                    <meta name="twitter:data1" content="1 minute" />
                    <meta name="twitter:label1" content="Est. reading time" />
                    <script type="application/ld+json" class="yoast-schema-graph">{JSON.stringify(yoast_head_json.schema)}</script> 
                   <script type="application/ld+json" class="yoast-schema-graph">{"@context":"https://schema.org","@graph":[{"@type":"WebSite","@id":"http://react-wordpress-theme.local/#website","url":"http://react-wordpress-theme.local/","name":"React Wordpress Theme","description":"Just another WordPress site","potentialAction":[{"@type":"SearchAction","target":{"@type":"EntryPoint","urlTemplate":"http://react-wordpress-theme.local/?s={search_term_string}"},"query-input":"required name=search_term_string"}],"inLanguage":"en-US"},{"@type":"WebPage","@id":"http://react-wordpress-theme.local/page-with-columns/#webpage","url":"http://react-wordpress-theme.local/page-with-columns/","name":"Page with columns - React Wordpress Theme","isPartOf":{"@id":"http://react-wordpress-theme.local/#website"},"datePublished":"2022-03-22T16:00:52+00:00","dateModified":"2022-03-22T16:01:07+00:00","breadcrumb":{"@id":"http://react-wordpress-theme.local/page-with-columns/#breadcrumb"},"inLanguage":"en-US","potentialAction":[{"@type":"ReadAction","target":["http://react-wordpress-theme.local/page-with-columns/"]}]},{"@type":"BreadcrumbList","@id":"http://react-wordpress-theme.local/page-with-columns/#breadcrumb","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"http://react-wordpress-theme.local/"},{"@type":"ListItem","position":2,"name":"Page with columns"}]}]}</script> */}
        </Helmet>
      ) : null}
    </>
  );
};

export default GlobalMeta;
